import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
  search: {
    hits: [],
    records: [],
    page: 1,
    pageSize: 10,
    nbPages: 0,
    nbHits: 0,
  
    totalPage: 4,
    total: 33
  },
  searchRequest: {
    page: 1,
    pageSize: 10,
    keyword: '',
    contentType: 'blog_article_page',
    sortBy: 'viewCount',
  }
}

const NAME = 'searchPage';
export const articlePageSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeSearch: (state, action) => {
      state.search = action.payload
    },
  
    changeSearchRequest: (state, action) => {
      state.searchRequest = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload[NAME]
      }
    })
  }
})

export const { changeSearch, changeSearchRequest } = articlePageSlice.actions;
export default articlePageSlice;
